// Для квиза и лендинга отдает локализованную дату
export function useDate() {
  const dayjs = useDayjs();
  const { locale } = useI18n();

  const localizedFormat = computed((): string => {
    switch (locale.value) {
      case 'es':
      case 'es-mx':
      case 'pt':
      case 'pt-br':
        return 'D [de] MMMM';
      case 'fr':
      case 'it':
        return 'D MMMM';
      default:
        return 'MMMM D';
    }
  });

  function getLocalizedDate(daysFromNow: number = 0): string {
    const date = dayjs().locale(locale.value).add(daysFromNow, 'day');

    return date.format(localizedFormat.value);
  }

  return {
    localizedFormat,
    getLocalizedDate,
  };
}
